(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('RegionDetailController', RegionDetailController);

    RegionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Region', 'Province', 'Country', 'Brokerage', 'AppraiserUser'];

    function RegionDetailController($scope, $rootScope, $stateParams, entity, Region, Province, Country, Brokerage, AppraiserUser) {
        var vm = this;

        vm.region = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:regionUpdate', function(event, result) {
            vm.region = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
